import React from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Lowes = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator ">

                </div>
                <div className="indicator ">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator selected">

                </div>
            </div>

            <div className="vivify fadeIn duration-500" style={{
                marginTop: '5vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'

            }}>
                <h1 className="large-text">Enjoy The Giftcard!</h1>
                <img style={{ width: '100%', height: 250, objectFit: 'cover' }} className="vivify fadeIn" src="/assets/lowes.png" alt="dad" />


                <h1 className="large-text"><CountUp prefix="You Went To Lowes " end={42} duration={5} /> Times This Year</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/dad');
                        }
                    } className="large-button">
                        Replay
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Lowes